import { Row, Col } from '@/components/ui'
import { StatCard } from './StatCard'
import { RegisteredIcon, AttendedIcon, PendingArrivalIcon } from '@/components/icons/EventsIcons'

interface StatsSectionProps {
  registeredCount: number
  approvedCount: number
  pendingApprovalCount: number
}

export function StatsSection({
  registeredCount,
  approvedCount,
  pendingApprovalCount,
}: StatsSectionProps) {
  return (
    <div className="p-6 pb-4">
      <Row gutter={16}>
        <Col span={8}>
          <StatCard
            icon={<RegisteredIcon />}
            count={registeredCount}
            label="Registered"
            colorScheme="blue"
          />
        </Col>
        <Col span={8}>
          <StatCard
            icon={<AttendedIcon />}
            count={approvedCount}
            label="Approved"
            colorScheme="green"
          />
        </Col>
        <Col span={8}>
          <StatCard
            icon={<PendingArrivalIcon />}
            count={pendingApprovalCount}
            label="Pending Approval"
            colorScheme="yellow"
          />
        </Col>
      </Row>
    </div>
  )
}
